import React,{useState,useEffect,useRef} from 'react'
import Countdown from 'react-countdown'
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import $ from "jquery";
import axios from 'axios';
import '../inc/GlobalVars';
import   submitBid   from "../inc/hooks/submitBid";
function WinsList(props) {

  const bidId = useRef(null);
  const user_id = localStorage.getItem('userId'); 
const bidNow = (vehicleId) => {
  bidId.current.value = vehicleId;
};
    const renderer = ({hours,minutes,seconds}) => {
        return(
            <div>
                <span className="time">{hours}</span>
                <span>:</span>
                <span className="time">{minutes}</span>
                <span>:</span>
                <span className="time">{seconds}</span>
                
            </div>
        )
    }
    const data = { bid_amount:""}
const [inputData, setInputData] = useState(data);

const handleData = (e) =>
{
    setInputData({...inputData,[e.target.name]:e.target.value});
}
const [res, setRes] = useState('');
const handleBidding = async(e) => {
  e.preventDefault();
  //$("#exampleModal"+props.vehicle_id).modal('hide');
  //var da= {bid_amount:inputData.bid_amount,userId:user_id,vehicle_id:bidId.current.value}
  
  const bid_amount = inputData.bid_amount;
  const vehicleId = bidId.current.value; // Get vehicle ID from form
  //await submitBid(bid_amount, vehicleId);
  const res = await submitBid(bid_amount, vehicleId);
  setRes(res);
}

//const manage_status = props.manage_status;
  function get_text(manage_status) {
    if(manage_status ==0 )
    {
        return(
            <>
                <span className='text-danger' style={{fontWeight:"bold"}}>Approval Pending</span>
            </>
        )
    }
    if(manage_status ==1 )
    {
        return(
            <>
                <span className='text-danger' style={{fontWeight:"bold"}}>Rejected</span>
            </>
        )
    }
    if(manage_status ==2 )
    {
        return(
            <>
                <span className='text-success' style={{fontWeight:"bold"}}>Approved</span>
            </>
        )
    }
    if(manage_status ==3 )
    {
        return(
            <>
                <span className='text-danger' style={{fontWeight:"bold"}}>Quote Revision</span>
            </>
        )
    }
    if(manage_status ==4 )
    {
        return(
            <>
                <span className='text-success' style={{fontWeight:"bold"}}>Fulfilled</span>
            </>
        )
    }
    if(manage_status ==5 )
    {
        return(
            <>
                <span className='text-warning' style={{fontWeight:"bold"}}>Vehicle Lifted</span>
            </>
        )
    }
    if(manage_status ==6 )
    {
        return(
            <>
                <span className='text-danger' style={{fontWeight:"bold"}}>Fees Pending</span>
            </>
        )
    }
    if(manage_status ==7 )
    {
        return(
            <>
                <span className='text-success' style={{fontWeight:"bold"}}>RC Transfered</span>
            </>
        )
    }
    if(manage_status ==8 )
    {
        return(
            <>
                <span className='text-danger' style={{fontWeight:"bold"}}>Buyer Backout</span>
            </>
        )
    }
    if(manage_status ==9 )
      {
          return(
              <>
                  <span className='text-warning' style={{fontWeight:"bold"}}>Under Auction</span>
              </>
          )
      }

  }
  

  return (
    <div className='container auction-list-card mt-2'>
       <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
        <div className='row d-flex justify-content-center align-items-center'>
            <div className='col-md-4 position-relative'>
            <span className={props.bid_win_status == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{props.bid_win_status == "no" ? "Losing" : "Winning"}</span>

            <Link to={"/vehicleDetails/"+props.vehicle_id} className="text-decoration-none text-black"><img
              src={props.featured_image}
              className="img-fluid carCarImage"
            /></Link>
            </div>

            <div className='col-md-8'>
            <div className='carCard'>
            <Link to={"/vehicleDetails/"+props.vehicle_id} className="text-decoration-none text-black"><h3 style={{textTransform:"capitalize"}}>{props.make_name+" "+props.model}</h3></Link>
            <ul className="list-group">
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="fw-bold">Registration Number</span>
                <span className="fw-bold" style={{textTransform:"uppercase"}} >{props.reg_number}</span>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="fw-bold">Bid Status</span>
                {
                    get_text(props.manage_status)
                }
              
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="fw-bold">Fuel Type</span>
                <span className="fw-bold">{props.fuel_type}</span>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="fw-bold">Rc Availability</span>
                <span className={props.rc_availability == 1 ? "text-success fw-bold" : "text-danger fw-bold"}> {props.rc_availability == 1 ? "Yes" : "No"}</span>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
              <span className="fw-bold">Location</span>
                <span className="fw-bold" style={{textTransform:"capitalize"}}>{props.location}</span>
                
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="fw-bold">My Bid</span>
                <span className="auction-min-bid fw-bold">&#8377; {props.bid_amount}</span>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="fw-bold">Bid Date</span>
                <span className="fw-bold">{props.bid_time}</span>
              </li>
            </ul>
                
                </div>
                <div className="col-md-12" style={{flex:"1"}}>
                <button onClick={() => bidNow(props.vehicle_id)} value={props.vehicle_id} data-bs-toggle="modal" data-bs-target={"#exampleModal"+props.vehicle_id} className="btn btn-primary carCardButton">BID NOW</button>
            </div>
            </div>
        </div>
        <div className='row'>
          <div className="col-md-12 mt-3">
            <ul className="list-group">
            <li className="list-group-item  d-flex align-items-center">
                <p className='p-0 m-0'>All the extra accessories, fitted by insurer, can be removed by him at the time of lifting</p>
              </li>
              <li className="list-group-item  d-flex align-items-center">
                <p className='p-0 m-0'>Request would not be entertained at the time of lifting of the vehicle post approval to any vehicle missing parts and/or parking charges(if any)</p>
              </li>
            </ul>
          </div>
        </div>


        <div className="modal fade" id={"exampleModal"+props.vehicle_id} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content" style={{background:"#edfbfb"}}>
      <div className="modal-header p-0 m-0" >
        
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{position: "absolute",
    right: "-7px",
    color: "#fff",
    top: "-4px",
    filter: "invert(1)"}}></button>
      </div>
      <div className="modal-body">
      {props.can_bid == "yes" ? (
        <>
        <form method="POST" encType="multipart/form-data">
          <input type="hidden" name="user_id" value={user_id} />
          <input type="hidden" name="vehicle_id" ref={bidId} />
          <h3 style={{textTransform:"capitalize",textAlign:"center"}}>Place Your Bid</h3>
            <ul className="list-group">
              
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Status</span>
                <span className={props.bid_win_status == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{props.bid_win_status == "no" ? "Losing" : "Winning"}</span>

              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Amount</span>
                <span className="fw-bold">&#8377; {props.bid_max_amount == null ? "0" : props.bid_max_amount}</span>
              </li>
              

            </ul>
          <div className="mb-2 mt-4 input-wrapper">
            <label>Bid Amount <span className="text-danger">*</span></label>
            <input type="text" className="form-control"  value={inputData.bid_amount} onChange={handleData} placeholder="Enter Bid Amount" name="bid_amount" required />
          </div>
          <div className="mt-3">
            <button type="submit" onClick={handleBidding} className="btn btn-primary carCardButton" >Submit Now</button>
          </div>
          {res != null ? (
                  <div className="text-center mt-2" style={{padding:"4px 5px",borderRadius:"5px"}}>
                <h4 className="text-danger text-danger" >{res}</h4>
                </div>
                ) : ''}
          
          </form>
        </>) : (
                  <>
                  <input type="hidden" name="user_id" value={user_id} />
                  <input type="hidden" name="vehicle_id" ref={bidId} />
                  <h3 style={{textTransform:"capitalize",textAlign:"center"}}>Place Your Bid</h3>
                  <p className="text-center text-danger"><b>You are restricted to place bid on this vehicle</b></p>
                </>
                )}
      </div>
      
    </div>
  </div>
</div>
    </div>
  )
}

export default WinsList